export const API = process.env.REACT_APP_BACKEND_URL;
// JWT for the admin panel is stored in localStorage following the standard SPA pattern.
// Trade-off: localStorage is XSS-readable, so this assumes the rest of the app does not
// render unsanitised user-supplied HTML (verified — all user content flows through React's
// default text-escaping; no dangerouslySetInnerHTML on user data). If we ever need to harden
// further, migrate to HttpOnly cookies + CSRF token (requires backend session middleware).
export const TOKEN_KEY = 'taylord_admin_token';
export const MAX_IMAGE_BYTES = 4 * 1024 * 1024;

export const authHeaders = () => {
  const t = localStorage.getItem(TOKEN_KEY);
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const apiErr = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || 'Something went wrong';
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(' ');
  return String(d);
};
